import React from "react";
import { useNavigate } from "react-router-dom";

const tiles = [
  { label: "Driver Onboarding", path: "/driver-onboarding", icon: "👤", desc: "Register & manage drivers" },
  { label: "Attendance", path: "/driver-attendance-approval", icon: "📅", desc: "Mark & approve attendance" },
  { label: "Attendance Records", path: "/attendance-records", icon: "📋", desc: "View historical records" },
  { label: "Leave Requests", path: "/driver-leave-admin", icon: "🏖️", desc: "Manage driver leaves" },
  { label: "Advance", path: "/driver-advance", icon: "💰", desc: "Driver advance requests" },
  { label: "Salary", path: "/driver-salary", icon: "💵", desc: "Payroll & salary processing" },
  { label: "Deduction", path: "/driver-deduction", icon: "📉", desc: "Track driver deductions" },
  { label: "Driver Timesheet", path: "/driver-timeSheet", icon: "⏱️", desc: "Duty hours tracking" },
  { label: "Live Tracking", path: "/driver-liveTracking", icon: "📍", desc: "Real-time driver location" },
];

export default function DriverManagement() {
  const nav = useNavigate();

  const s = {
    container: {
      fontFamily: "Arial, sans-serif",
      marginLeft: "278px",
      marginRight: "10px",
      backgroundColor: "#ffffff",
      color: "#000000",
      minHeight: "100vh",
    },
    pageHeader: {
      backgroundColor: "#FFC107",
      padding: "16px 24px",
      marginBottom: "0px",
    },
    pageHeaderText: {
      fontSize: "22px",
      fontWeight: "700",
      color: "#000000",
      letterSpacing: "1px",
      textTransform: "uppercase",
      margin: 0,
    },
    contentBody: {
      padding: "24px",
    },
    sectionTitle: {
      fontSize: "15px",
      fontWeight: "700",
      color: "#000000",
      marginBottom: "4px",
    },
    sectionDivider: {
      border: "none",
      borderTop: "2px solid #FFC107",
      marginBottom: "20px",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: "18px",
    },
    tile: {
      backgroundColor: "#ffffff",
      border: "1.5px solid #000000",
      borderRadius: "0",
      padding: "28px 16px",
      textAlign: "center",
      cursor: "pointer",
      transition: "all 0.15s",
    },
    tileIcon: {
      fontSize: "34px",
      marginBottom: "10px",
    },
    tileLabel: {
      fontWeight: "700",
      fontSize: "13px",
      marginBottom: "6px",
      color: "#000000",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    tileDesc: {
      fontSize: "12px",
      color: "#555555",
    },
  };

  return (
    <div style={s.container}>
      {/* Yellow header bar */}
      <div style={s.pageHeader}>
        <h1 style={s.pageHeaderText}>Driver Management</h1>
      </div>

      <div style={s.contentBody}>
        <div style={s.sectionTitle}>Modules</div>
        <hr style={s.sectionDivider} />

        <div style={s.grid}>
          {tiles.map((t) => (
            <div
              key={t.path}
              style={s.tile}
              onClick={() => nav(t.path)}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#FFC107";
                e.currentTarget.style.borderColor = "#FFC107";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#ffffff";
                e.currentTarget.style.borderColor = "#000000";
              }}
            >
              <div style={s.tileIcon}>{t.icon}</div>
              <div style={s.tileLabel}>{t.label}</div>
              <div style={s.tileDesc}>{t.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}